export const calculatePastYears = () => {
  const openingDate = new Date('1992-09-01');
  const currentDate = new Date();

  let years = currentDate.getFullYear() - openingDate.getFullYear();

  // Check if the birthday has already occurred this year
  const hasHadBirthdayThisYear =
    currentDate.getMonth() > openingDate.getMonth() ||
    (currentDate.getMonth() === openingDate.getMonth() &&
      currentDate.getDate() >= openingDate.getDate());

  if (!hasHadBirthdayThisYear) {
    years--;
  }

  return years;
};
